/* ============================================================
   War Record â€” Animations v2
   Glitch Â· CA Â· Typewriter Â· Scramble Â· Reveal Â· Counters Â· Particles
   ============================================================ */

(function () {
  'use strict';

  /* ----------------------------------------------------------
     UTILS
  ---------------------------------------------------------- */
  const GLITCH_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*<>?/\\|[]{}';

  function randomChar() {
    return GLITCH_CHARS[Math.floor(Math.random() * GLITCH_CHARS.length)];
  }

  /* ----------------------------------------------------------
     1. GLITCH â€” randomly triggers on [data-glitch] elements
        Now includes text scramble for dramatic effect
  ---------------------------------------------------------- */
  function initGlitch() {
    const els = document.querySelectorAll('[data-glitch]');
    els.forEach(el => {
      const scheduleGlitch = () => {
        const delay = 2500 + Math.random() * 5000;
        setTimeout(() => {
          /* CSS-only glitch â€” never touch textContent/innerHTML so inner spans
             and injected ghost elements are never destroyed */
          el.classList.add('is-glitching');
          setTimeout(() => {
            el.classList.remove('is-glitching');
            scheduleGlitch();
          }, 380);
        }, delay);
      };
      scheduleGlitch();
    });
  }


  /* ----------------------------------------------------------
     HOVER SCRAMBLE â€” CSS-only CA burst on card headings
     Never touches textContent â€” pure visual effect only
  ---------------------------------------------------------- */
  function initHoverScramble() {
    const selectors = [
      '.header__menu-item',
      '.war-record-servicio-card__title',
      '.wr-testi-author__name',
      '.wr-gallery-item__title',
      '.wr-pt-card__head-name',
      '.wr-specs-card__name',
      '.wr-mat-card__name',
      '.wr-paso__num',
    ];
    selectors.forEach(sel => {
      document.querySelectorAll(sel).forEach(el => {
        let tid = null;
        el.addEventListener('mouseenter', () => {
          if (tid) clearTimeout(tid);
          el.style.textShadow = '-4px 0 rgba(255,0,80,.75), 4px 0 rgba(0,200,255,.75)';
          el.style.letterSpacing = '0.06em';
          tid = setTimeout(() => {
            el.style.textShadow = '-2px 0 rgba(255,0,80,.3), 2px 0 rgba(0,200,255,.3)';
            el.style.letterSpacing = '';
            setTimeout(() => { el.style.textShadow = ''; tid = null; }, 100);
          }, 140);
        });
        el.addEventListener('mouseleave', () => {
          if (tid) { clearTimeout(tid); tid = null; }
          el.style.textShadow = '';
          el.style.letterSpacing = '';
        });
      });
    });
  }

  /* ----------------------------------------------------------
     2. TYPEWRITER â€” types text char by char on [data-typewriter]
  ---------------------------------------------------------- */
  function initTypewriter() { /* eliminado — afecta experiencia del usuario */ }

  /* ----------------------------------------------------------
     3. SCROLL REVEAL â€” stagger fade-up on .wr-reveal elements
  ---------------------------------------------------------- */
  function initReveal() {
    const selectors = [
      '.war-record-servicio-card',
      '.war-record-stat',
      '.card-wrapper',
      '.multicolumn-card',
      '.title-wrapper:not(.collection__title)',
      '.image-with-text__content',
    ];

    selectors.forEach(sel => {
      document.querySelectorAll(sel).forEach((el, i) => {
        if (!el.classList.contains('wr-reveal')) {
          el.classList.add('wr-reveal');
          el.style.setProperty('--wr-delay', (i % 4) * 80 + 'ms');
        }
      });
    });

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        const delay = parseInt(el.style.getPropertyValue('--wr-delay')) || 0;
        setTimeout(() => {
          el.classList.add('wr-visible');
          /* Brief data-corrupt flash on reveal */
          if (Math.random() > 0.6) {
            el.classList.add('wr-data-corrupt');
            setTimeout(() => el.classList.remove('wr-data-corrupt'), 160);
          }
        }, delay);
        observer.unobserve(el);
      });
    }, { threshold: 0.08 });

    document.querySelectorAll('.wr-reveal').forEach(el => observer.observe(el));
  }

  /* ----------------------------------------------------------
     3.5. TEXT SCRAMBLE — decode + chromatic aberration en TODOS
          los titulos de seccion (hero excluido)
  ---------------------------------------------------------- */
  function initTextScramble() { /* eliminado — afecta experiencia del usuario */ }

  /* ----------------------------------------------------------
     4. STAT COUNTERS â€” animate numbers in .war-record-stat__num
  ---------------------------------------------------------- */
  function initCounters() {
    const els = document.querySelectorAll('.war-record-stat__num');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        const raw = el.textContent.trim();
        const match = raw.match(/^([+]?)(\d+)([+%]?)$/);
        if (!match) { observer.unobserve(el); return; }

        const prefix = match[1];
        const target = parseInt(match[2]);
        const suffix = match[3];
        const duration = 1800;
        const start = performance.now();

        const update = (now) => {
          const t = Math.min((now - start) / duration, 1);
          const eased = 1 - Math.pow(1 - t, 3);
          const current = Math.round(target * eased);

          /* Brief random char appended â€” cleared in next rAF tick, no setTimeout needed */
          if (t < 0.85 && Math.random() > 0.7) {
            el.textContent = prefix + current + suffix + randomChar();
          } else {
            el.textContent = prefix + current + suffix;
          }

          if (t < 1) requestAnimationFrame(update);
          else el.textContent = prefix + target + suffix;
        };

        requestAnimationFrame(update);
        observer.unobserve(el);
      });
    }, { threshold: 0.5 });

    els.forEach(el => observer.observe(el));
  }

  /* ----------------------------------------------------------
     5. CURSOR GLOW â€” subtle teal glow following cursor
  ---------------------------------------------------------- */
  function initCursorGlow() {
    if (window.matchMedia('(pointer: coarse)').matches) return;
    const glow = document.createElement('div');
    glow.className = 'wr-cursor-glow';
    document.body.appendChild(glow);
    let x = 0, y = 0, cx = 0, cy = 0;
    document.addEventListener('mousemove', e => { x = e.clientX; y = e.clientY; });
    const lerp = (a, b, t) => a + (b - a) * t;
    const animate = () => {
      cx = lerp(cx, x, 0.1);
      cy = lerp(cy, y, 0.1);
      glow.style.transform = `translate(${cx}px, ${cy}px)`;
      requestAnimationFrame(animate);
    };
    animate();
  }

  /* ----------------------------------------------------------
     6. PAGE LOAD BAR
  ---------------------------------------------------------- */
  function initLoadBar() {
    const bar = document.createElement('div');
    bar.className = 'wr-loadbar';
    document.body.appendChild(bar);
    setTimeout(() => bar.remove(), 1400);
  }

  /* ----------------------------------------------------------
     7. HERO PARTICLES â€” floating teal dots
  ---------------------------------------------------------- */
  function initParticles() {
    const hero = document.querySelector('.war-record-video-hero');
    if (!hero) return;

    const colors = [
      'rgba(0,159,176,0.7)',
      'rgba(0,159,176,0.4)',
      'rgba(0,200,216,0.5)',
      'rgba(0,159,176,0.25)',
    ];

    for (let i = 0; i < 22; i++) {
      const p = document.createElement('div');
      p.className = 'wr-particle';
      const size = 1.5 + Math.random() * 3;
      const color = colors[Math.floor(Math.random() * colors.length)];
      const duration = 22 + Math.random() * 28;
      const delay = Math.random() * -20;
      const drift = (Math.random() - 0.5) * 120;
      const left = Math.random() * 100;

      p.style.cssText = `
        width:${size}px; height:${size}px;
        background:${color};
        box-shadow: 0 0 ${size * 3}px ${color};
        left:${left}%;
        bottom:-10px;
        --drift:${drift}px;
        animation-duration:${duration}s;
        animation-delay:${delay}s;
      `;
      hero.appendChild(p);
    }

    /* Glitch blocks inside hero */
    for (let i = 0; i < 3; i++) {
      const block = document.createElement('div');
      block.className = 'wr-glitch-block';
      block.style.top = (20 + Math.random() * 60) + '%';
      block.style.animationDelay = (i * 1.8) + 's';
      hero.appendChild(block);
    }
  }

  /* ----------------------------------------------------------
     8. SCROLL HEADER â€” add .scrolled class on scroll
  ---------------------------------------------------------- */
  function initScrollHeader() {
    const onScroll = () => {
      document.body.classList.toggle('scrolled', window.scrollY > 50);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ----------------------------------------------------------
     9. DATA STREAM â€” matrix rain on hero
  ---------------------------------------------------------- */
  function initDataStream() {
    const hero = document.querySelector('.war-record-video-hero');
    if (!hero) return;

    const wrap = document.createElement('div');
    wrap.className = 'wr-ds-wrap';
    hero.appendChild(wrap);

    const MATRIX_CHARS = '01アイウエオカキクケコ><//\\{}[]!?';
    const cols = Math.floor(window.innerWidth / 20);

    for (let c = 0; c < Math.min(cols, 30); c++) {
      const col = document.createElement('div');
      col.className = 'wr-ds-col';
      const len = 8 + Math.floor(Math.random() * 16);
      let text = '';
      for (let r = 0; r < len; r++) {
        text += MATRIX_CHARS[Math.floor(Math.random() * MATRIX_CHARS.length)] + '\n';
      }
      col.textContent = text;
      col.style.left = (c / cols * 100) + '%';
      col.style.animationDuration = (16 + Math.random() * 22) + 's';
      col.style.animationDelay = (-Math.random() * 20) + 's';
      wrap.appendChild(col);
    }

    /* Periodically refresh chars */
    setInterval(() => {
      document.querySelectorAll('.wr-ds-col').forEach(col => {
        if (Math.random() > 0.7) {
          const len = 8 + Math.floor(Math.random() * 16);
          let text = '';
          for (let r = 0; r < len; r++) {
            text += MATRIX_CHARS[Math.floor(Math.random() * MATRIX_CHARS.length)] + '\n';
          }
          col.textContent = text;
        }
      });
    }, 4000);
  }

  /* ----------------------------------------------------------
     10. FAQ ACCORDION â€” CA on open
  ---------------------------------------------------------- */
  function initFaqAccordion() {
    /* CA flash on FAQ question open â€” uses correct class from liquid */
    document.querySelectorAll('.wr-faq-item__trigger').forEach(btn => {
      btn.addEventListener('click', () => {
        const item = btn.closest('.wr-faq-item');
        if (!item) return;
        const q = btn.querySelector('.wr-faq-item__q');
        if (!q) return;
        const willOpen = !item.classList.contains('open');
        if (!willOpen) return;
        /* 4-frame CA burst */
        q.style.textShadow = '-6px 0 rgba(255,0,80,0.88), 6px 0 rgba(0,200,255,0.88)';
        q.style.transform  = 'translateX(-2px)';
        setTimeout(() => {
          q.style.textShadow = '5px 0 rgba(255,0,80,0.6), -5px 0 rgba(0,200,255,0.6)';
          q.style.transform  = 'translateX(3px)';
        }, 75);
        setTimeout(() => {
          q.style.textShadow = '-3px 0 rgba(255,0,80,0.28), 3px 0 rgba(0,200,255,0.28)';
          q.style.transform  = '';
        }, 155);
        setTimeout(() => { q.style.textShadow = ''; }, 270);
      });
    });
  }

  /* ----------------------------------------------------------
     11. RANDOM GLITCH BURST â€” fires on random sections
  ---------------------------------------------------------- */
  function initRandomGlitch() {
    const candidates = document.querySelectorAll(
      '.wr-testimonials__title, .wr-gallery__title, .war-record-servicios__title, ' +
      '.wr-materiales__title, .wr-precios__title, .wr-specs__title, ' +
      '.collection__title.title-wrapper .title, .rich-text__heading'
    );
    if (!candidates.length) return;

    /* CSS-only: never touch textContent â€” avoids any rAF race condition */
    const fireRandom = () => {
      const el = candidates[Math.floor(Math.random() * candidates.length)];
      el.classList.add('wr-data-corrupt');
      /* Force reflow so animation restarts if same element is picked again */
      void el.offsetWidth;
      setTimeout(() => el.classList.remove('wr-data-corrupt'), 180);
      setTimeout(fireRandom, 4000 + Math.random() * 8000);
    };

    setTimeout(fireRandom, 5000);
  }

  /* ----------------------------------------------------------
     12. MAGNETIC BUTTONS â€” subtle cursor attraction on primary CTAs
  ---------------------------------------------------------- */
  function initMagneticButtons() {
    if (window.matchMedia('(pointer: coarse)').matches) return;
    const btns = document.querySelectorAll(
      '.button--primary, .wr-prefooter__btn-wa, .wr-cot-btn--primary, .wr-rep__btn--primary'
    );
    btns.forEach(btn => {
      let rect = null;
      btn.addEventListener('mouseenter', () => { rect = btn.getBoundingClientRect(); });
      btn.addEventListener('mousemove', e => {
        if (!rect) return;
        const cx = rect.left + rect.width / 2;
        const cy = rect.top + rect.height / 2;
        const dx = (e.clientX - cx) * 0.25;
        const dy = (e.clientY - cy) * 0.25;
        btn.style.transform = `translate(${dx}px, ${dy}px)`;
      });
      btn.addEventListener('mouseleave', () => {
        rect = null;
        btn.style.transform = '';
      });
    });
  }

  /* ----------------------------------------------------------
     13. CLICK CA RIPPLE â€” chromatic aberration burst on click
  ---------------------------------------------------------- */
  function initClickRipple() {
    if (window.matchMedia('(pointer: coarse)').matches) return;
    document.addEventListener('click', e => {
      const ripple = document.createElement('div');
      ripple.className = 'wr-click-ripple';
      ripple.style.left = e.clientX + 'px';
      ripple.style.top = e.clientY + 'px';
      document.body.appendChild(ripple);
      setTimeout(() => ripple.remove(), 600);
    });
  }

  /* ----------------------------------------------------------
     14. SECTION HEADING CA BURST â€” fires as heading enters viewport
  ---------------------------------------------------------- */
  function initHeadingCA() {
    const headings = document.querySelectorAll(
      '.wr-nosotros__title, .wr-proceso__title, .wr-materiales__title, ' +
      '.wr-testimonials__title, .wr-faq__title, .wr-gallery__title, ' +
      '.wr-precios__title, .wr-specs__title, .wr-cta-cot__title, .wr-rep__title, ' +
      '.war-record-servicios__title, .wr-porque__title, ' +
      '.collection__title.title-wrapper .title, .rich-text__heading'
    );
    const obs = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        /* Staggered CA burst: 3 flashes */
        [0, 120, 240].forEach(delay => {
          setTimeout(() => {
            el.style.textShadow = `-4px 0 rgba(255,0,80,${0.7 - delay/400}), 4px 0 rgba(0,200,255,${0.7 - delay/400})`;
            setTimeout(() => { el.style.textShadow = ''; }, 80);
          }, delay);
        });
        obs.unobserve(el);
      });
    }, { threshold: 0.3 });
    headings.forEach(h => obs.observe(h));
  }

  /* ----------------------------------------------------------
     15. STICKY WHATSAPP BUTTON â€” floating pulse with tooltip
  ---------------------------------------------------------- */
  function initStickyWA() {
    // Guard: prevent double initialization
    if (document.querySelector('.wr-wa-sticky')) return;

    // Remove ALL legacy static buttons (cualquier version)
    document.querySelectorAll('.war-record-whatsapp-btn').forEach(function(el) { el.remove(); });

    const WA_HREF = 'https://wa.me/5493515922788?text=Hola!%20Vi%20su%20tienda%20online%20y%20quiero%20consultar%20por%20un%20pedido.';

    const wrap = document.createElement('div');
    wrap.className = 'wr-wa-sticky';
    wrap.innerHTML = `
      <div class="wr-wa-sticky__tooltip">¡Consultá gratis!</div>
      <a href="${WA_HREF}" target="_blank" rel="noopener" class="wr-wa-sticky__btn" aria-label="Contactar por WhatsApp">
        <svg viewBox="0 0 24 24" fill="currentColor" width="26" height="26">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
        </svg>
      </a>
    `;
    document.body.appendChild(wrap);

    /* Show tooltip on first visit */
    setTimeout(() => wrap.classList.add('wr-wa-sticky--show-tip'), 3000);
    setTimeout(() => wrap.classList.remove('wr-wa-sticky--show-tip'), 7000);

    /* Re-show tooltip every 30s */
    setInterval(() => {
      wrap.classList.add('wr-wa-sticky--show-tip');
      setTimeout(() => wrap.classList.remove('wr-wa-sticky--show-tip'), 4000);
    }, 30000);
  }

  /* ----------------------------------------------------------
     16. STAT COUNTERS EXTENDED â€” also animate .wr-nosotros-stat__num
  ---------------------------------------------------------- */
  function initNosotrosCounters() {
    const els = document.querySelectorAll('.wr-nosotros-stat__num, .wr-rep__diag-num');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        const raw = el.textContent.trim();
        const match = raw.match(/^([+]?)(\d+)([+%a-zA-Z]*)$/);
        if (!match) { observer.unobserve(el); return; }
        const prefix = match[1];
        const target = parseInt(match[2]);
        const suffix = match[3];
        const duration = 1400;
        const start = performance.now();
        const update = (now) => {
          const t = Math.min((now - start) / duration, 1);
          const eased = 1 - Math.pow(1 - t, 3);
          const current = Math.round(target * eased);
          el.textContent = prefix + current + suffix;
          if (t < 1) requestAnimationFrame(update);
          else el.textContent = prefix + target + suffix;
        };
        requestAnimationFrame(update);
        observer.unobserve(el);
      });
    }, { threshold: 0.5 });
    els.forEach(el => observer.observe(el));
  }

  /* ----------------------------------------------------------
     17. SCROLL PROGRESS BAR â€” thin teal line at top of page
  ---------------------------------------------------------- */
  function initScrollProgress() {
    const bar = document.createElement('div');
    bar.className = 'wr-scroll-progress';
    document.body.appendChild(bar);
    let scrollTotal = document.documentElement.scrollHeight - window.innerHeight;
    window.addEventListener('resize', () => {
      scrollTotal = document.documentElement.scrollHeight - window.innerHeight;
    }, { passive: true });
    window.addEventListener('scroll', () => {
      bar.style.width = Math.min((window.scrollY / scrollTotal) * 100, 100) + '%';
    }, { passive: true });
  }

  /* ----------------------------------------------------------
     18. URGENCY COUNTER â€” live "pedidos este mes" ticker
  ---------------------------------------------------------- */
  function initUrgencyTicker() {
    const els = document.querySelectorAll('[data-urgency-count]');
    els.forEach(el => {
      const base = parseInt(el.dataset.urgencyCount) || 47;
      /* Randomize slightly around the base */
      const displayed = base + Math.floor(Math.random() * 8);
      el.textContent = displayed;
      /* Increment occasionally */
      setInterval(() => {
        if (Math.random() > 0.85) {
          el.textContent = parseInt(el.textContent) + 1;
          el.style.color = '#009FB0';
          el.style.transform = 'scale(1.15)';
          setTimeout(() => {
            el.style.color = '';
            el.style.transform = '';
          }, 400);
        }
      }, 45000);
    });
  }

  /* ----------------------------------------------------------
     19. 3D CARD TILT â€” mouse-tracking perspective tilt
  ---------------------------------------------------------- */
  function initCardTilt() {
    if (window.matchMedia('(pointer: coarse)').matches) return;
    const cards = document.querySelectorAll(
      '.war-record-servicio-card, .wr-specs-card, .wr-mat-card, .wr-testi-card'
    );
    cards.forEach(card => {
      let rect = null;
      card.addEventListener('mouseenter', () => { rect = card.getBoundingClientRect(); });
      card.addEventListener('mousemove', e => {
        if (!rect) return;
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        const cx = rect.width / 2;
        const cy = rect.height / 2;
        const rotX = ((y - cy) / cy) * -6;
        const rotY = ((x - cx) / cx) * 6;
        card.style.transform = `perspective(800px) rotateX(${rotX}deg) rotateY(${rotY}deg) translateZ(4px)`;
      });
      card.addEventListener('mouseleave', () => {
        card.style.transform = '';
      });
    });
  }

  /* ----------------------------------------------------------
     19b. HERO HEADING RAPID EFFECTS â€” extra JS layer on top of CSS
          Fires scramble + inline bursts between CSS animation phases
  ---------------------------------------------------------- */
  function initHeroHeadingEffects() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const h1 = document.querySelector('.war-record-video-hero__heading');
    if (!h1) return;
    const span = h1.querySelector('span');

    /* â”€â”€ RGB ghost layers — pre-rendered in Liquid, JS only populates content â”€â”€
       Capture text HTML excluding pre-rendered ghost/overlay divs */
    const tempH1 = h1.cloneNode(true);
    tempH1.querySelectorAll('.wr-hero-ghost, .wr-hero-scramble-overlay').forEach(el => el.remove());
    const origHTML = tempH1.innerHTML;

    const ghostR = h1.querySelector('.wr-hero-ghost--red')   || (() => { const el = document.createElement('div'); el.className = 'wr-hero-ghost wr-hero-ghost--red';  el.setAttribute('aria-hidden','true'); h1.appendChild(el); return el; })();
    const ghostC = h1.querySelector('.wr-hero-ghost--cyan')  || (() => { const el = document.createElement('div'); el.className = 'wr-hero-ghost wr-hero-ghost--cyan'; el.setAttribute('aria-hidden','true'); h1.appendChild(el); return el; })();
    const ghostL = h1.querySelector('.wr-hero-ghost--lime')  || (() => { const el = document.createElement('div'); el.className = 'wr-hero-ghost wr-hero-ghost--lime'; el.setAttribute('aria-hidden','true'); h1.appendChild(el); return el; })();
    ghostR.innerHTML = origHTML;
    ghostC.innerHTML = origHTML;
    ghostL.innerHTML = origHTML;

    /* â”€â”€ JS Burst pool â”€â”€
       Format: [textShadow h1, textShadow span, transform h1, filter h1, duration ms]
       'none' = clear the property   '' = leave unchanged */
    const jsBursts = [
      /* CA soft */
      ['-6px 0 rgba(255,0,80,.75), 6px 0 rgba(0,200,255,.75)',  '5px 0 rgba(255,0,80,.75), -5px 0 rgba(0,200,255,.75)',   'translate(-1px, 0.5px)', '',                                            80],
      /* Neon glow flare */
      ['0 0 40px rgba(0,159,176,1), 0 0 80px rgba(0,159,176,.5)','0 0 30px rgba(0,200,255,.9)',                           'translate(-1px, 1px)', 'brightness(1.3)',                             420],
      /* CA medium */
      ['-10px 0 rgba(255,0,80,.9), 10px 0 rgba(0,200,255,.9)',   '8px 0 rgba(255,0,80,.9), -8px 0 rgba(0,200,255,.9)',    'translate(-3px, 1px)', '',                                            55],
      /* CA hard + letter expand */
      ['-16px 0 rgba(255,0,80,1), 16px 0 rgba(0,200,255,1)',     '12px 0 rgba(255,0,80,1), -12px 0 rgba(0,200,255,1)',    'translate(2px, -2px)', '',                                            40],
      /* Wave distortion */
      ['-4px 0 rgba(255,0,80,.5), 4px 0 rgba(0,200,255,.5)',     '-4px 0 rgba(255,0,80,.5), 4px 0 rgba(0,200,255,.5)',   'skewX(4deg) translate(-3px, 1px)',  'blur(0.4px)',     180],
      /* Wave opposite */
      ['-3px 0 rgba(255,0,80,.4), 3px 0 rgba(0,200,255,.4)',     '',                                                      'skewX(-3.5deg) translate(3px, -1px)','',               150],
      /* White overload flash */
      ['0 0 2px #fff, 0 0 8px rgba(0,232,255,1)',                '0 0 2px #fff, 0 0 10px rgba(255,107,0,1)',              'translate(0.5px, 1px)', 'brightness(2) contrast(0.6)',                  35],
      /* Static noise burst */
      ['none',                                                    'none',                                                  'translate(-1px, -1px)', 'contrast(220%) brightness(1.9) saturate(0)',  30],
      /* Static inverse */
      ['none',                                                    'none',                                                  'translate(1px, 2px)', 'contrast(180%) brightness(0.4) invert(0.15)', 25],
      /* Datamosh sim â€” hue shift + shake */
      ['-7px 0 rgba(255,0,80,.8), 7px 0 rgba(0,200,255,.8)',     '',                                                      'translate(-5px, 2px)', 'hue-rotate(-35deg) saturate(3) brightness(1.3)', 90],
      /* Datamosh reverse */
      ['6px 0 rgba(255,0,80,.7), -6px 0 rgba(0,200,255,.7)',     '',                                                      'translate(4px, -1px)',   'hue-rotate(25deg) saturate(2.5)',               70],
      /* Orange neon on span only */
      ['0 0 20px rgba(0,159,176,.6)',                             '0 0 2px #fff, 0 0 12px rgba(255,107,0,1), 0 0 28px rgba(255,107,0,.5)', 'translate(-0.5px, -1px)', '', 500],
      /* RGB split wide */
      ['0 0 60px rgba(255,0,80,.35), -8px 0 rgba(255,0,80,.85), 8px 0 rgba(0,200,255,.85)', '0 0 40px rgba(0,200,255,.35), 6px 0 rgba(255,0,80,.75), -6px 0 rgba(0,200,255,.75)', 'translate(-2px, 1.5px)', 'saturate(1.9)', 110],
      /* Triple CA + skew (maxfx) */
      ['-22px 0 rgba(255,0,80,1), 18px 0 rgba(0,200,255,1), 0 0 50px rgba(204,255,0,.35)', '-14px 0 rgba(255,0,80,.95), 14px 0 rgba(0,200,255,.95)', 'skewX(-6deg) translate(-4px,2px)', 'contrast(2.1) brightness(1.15)', 48],
      ['22px 0 rgba(0,200,255,.95), -16px 0 rgba(255,0,80,.9)', '', 'skewX(5deg) translate(5px,-2px)', 'hue-rotate(40deg) saturate(2.8)', 42],
      /* Strobe + invert micro */
      ['0 0 1px #fff, -12px 0 rgba(255,0,80,1), 12px 0 rgba(0,200,255,1)', '0 0 1px #fff', 'scale(1.02) translate(-1px,-1px)', 'invert(0.08) contrast(2.6)', 28],
      /* Heavy blur tear */
      ['-14px 0 rgba(255,0,80,.9), 12px 0 rgba(0,200,255,.9)', '', 'translate(3px,4px)', 'blur(1.2px) saturate(3)', 65],
      /* Clean pause */
      ['none',                                                    'none',                                                  'none', '',                                            160],
    ];

    let burstIdx = 0;

    const fireBurst = () => {
      const [ts1, ts2, tf1, fi1, dur] = jsBursts[burstIdx % jsBursts.length];
      burstIdx++;

      if (ts1 !== '') h1.style.textShadow = ts1;
      if (tf1)        h1.style.transform  = tf1;
      if (fi1)        h1.style.filter     = fi1;
      if (span && ts2 !== '') span.style.textShadow = ts2;

      setTimeout(() => {
        h1.style.textShadow = '';
        h1.style.transform  = '';
        h1.style.filter     = '';
        if (span) span.style.textShadow = '';
        setTimeout(fireBurst, 350 + Math.random() * 900);
      }, dur);
    };

    /* Start soon after paint; cadence faster for maxfx */
    setTimeout(fireBurst, 1400);
  }

  /* ----------------------------------------------------------
     20. CYCLIC TITLE EFFECTS â€” JS-driven effect rotation on titles
         Applies different CA/glitch effects sequentially so each
         section heading cycles through all animation styles
  ---------------------------------------------------------- */
  function initCyclicTitleEffects() {
    /* Excluye .wr-home-collection: titulos de producto ya van con glow CSS suave */
    const selectors = ['.title-wrapper .title'];

    /* Effect class -> CSS applied inline (avoids class conflicts) */
    const effects = [
      /* name, textShadow, transform, filter, duration */
      { name: 'ca-soft',   ts: '-3px 0 rgba(255,0,80,0.6), 3px 0 rgba(0,200,255,0.6)',  tf: 'translate(-1px, 0.5px)',    fi: '',                               dur: 200 },
      { name: 'ca-hard',   ts: '-7px 0 rgba(255,0,80,0.9), 7px 0 rgba(0,200,255,0.9)',  tf: 'translate(2px, -1px)',     fi: '',                               dur: 150 },
      { name: 'neon',      ts: '0 0 22px rgba(0,159,176,1), 0 0 44px rgba(0,159,176,.4)', tf: 'translate(0, 0.5px)',      fi: 'brightness(1.15)',               dur: 700 },
      { name: 'corrupt',   ts: '',                                                         tf: 'translate(-2px, 1px)',     fi: 'hue-rotate(-16deg) saturate(2.2) brightness(1.2)', dur: 100 },
      { name: 'split-h',   ts: '-6px 0 rgba(255,0,80,0.8), 6px 0 rgba(0,200,255,0.8)',  tf: 'translate(1.5px, -0.5px)',  fi: '',                               dur: 180 },
      { name: 'burst',     ts: '-9px 0 rgba(255,0,80,1),   9px 0 rgba(0,200,255,1)',     tf: 'translate(-2px, -1.5px)',  fi: '',                               dur: 80  },
    ];

    const titleEls = [];
    selectors.forEach(sel => {
      document.querySelectorAll(sel).forEach(el => {
        if (!titleEls.includes(el)) titleEls.push(el);
      });
    });

    titleEls.forEach((el, i) => {
      /* Each title runs its own independent sequence — includes .wr-home-collection titles */
      let seq = i % effects.length; /* start at different point per title */

      const runNext = () => {
        const pause = 2800 + Math.random() * 4200;
        setTimeout(() => {
          const eff = effects[seq % effects.length];
          seq++;

          /* Apply effect */
          el.style.textShadow = eff.ts;
          el.style.transform  = eff.tf;
          el.style.filter     = eff.fi;

          /* Phase 2 â€” reduce */
          setTimeout(() => {
            el.style.textShadow = eff.ts ? eff.ts.replace(/0\.\d+\)/g, '0.2)') : '';
            el.style.filter     = '';
            el.style.transform  = '';
          }, eff.dur);

          /* Phase 3 â€” clear */
          setTimeout(() => {
            el.style.textShadow = '';
            el.style.transform  = '';
            el.style.filter     = '';
            runNext();
          }, eff.dur + 120);
        }, pause);
      };

      /* Stagger start per element */
      setTimeout(runNext, 1200 + i * 600);
    });
  }

  /* ----------------------------------------------------------
     PROCESS CONNECTOR â€” eliminado: molesta al usuario
  ---------------------------------------------------------- */
  function initProcessConnector() {}

  /* ----------------------------------------------------------
     21. SECTION LABELS â€” terminal "// READY" flash on section entry
  ---------------------------------------------------------- */
  function initSectionLabels() {
    if (window.matchMedia('(pointer: coarse)').matches) return;
    const sections = document.querySelectorAll(
      '.wr-proceso, .wr-gallery, .wr-testimonials, .wr-materiales, .wr-porque, .war-record-servicios__wrap'
    );
    const obs = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const section = entry.target;
        /* Brief terminal label that fades */
        const label = document.createElement('div');
        label.style.cssText = [
          'position:absolute',
          'top:8px',
          'right:12px',
          'font-family:\'Share Tech Mono\',monospace',
          'font-size:0.55rem',
          'letter-spacing:0.2em',
          'color:rgba(0,159,176,0.45)',
          'pointer-events:none',
          'z-index:10',
          'animation:wr-label-flash 2.5s ease forwards'
        ].join(';');
        label.textContent = '// READY';
        if (getComputedStyle(section).position === 'static') {
          section.style.position = 'relative';
        }
        section.appendChild(label);
        setTimeout(() => label.remove(), 2600);
        obs.unobserve(section);
      });
    }, { threshold: 0.2 });
    sections.forEach(s => obs.observe(s));
  }

  /* ----------------------------------------------------------
     22. STAT COUNTER CA FLASH â€” CA burst when counter completes
  ---------------------------------------------------------- */
  function initStatCompleteCA() {
    const statEls = document.querySelectorAll('.war-record-stat__num, .wr-nosotros-stat__num, .wr-rep__diag-num');
    const obs = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        /* After counter finishes (~1.8s), fire CA burst */
        setTimeout(() => {
          el.style.textShadow = '-4px 0 rgba(255,0,80,0.8), 4px 0 rgba(0,200,255,0.8)';
          setTimeout(() => {
            el.style.textShadow = '2px 0 rgba(255,0,80,0.4), -2px 0 rgba(0,200,255,0.4)';
            setTimeout(() => { el.style.textShadow = ''; }, 100);
          }, 100);
        }, 1900);
        obs.unobserve(el);
      });
    }, { threshold: 0.5 });
    statEls.forEach(el => obs.observe(el));
  }

  /* ----------------------------------------------------------
     23. RANDOM SCAN GLITCH â€” periodic CA burst on random section titles
  ---------------------------------------------------------- */
  function initTitleGlitchBurst() {
    const candidates = document.querySelectorAll(
      '.wr-nosotros__title, .war-record-servicios__title, .wr-gallery__title, ' +
      '.wr-proceso__title, .wr-faq__title, .wr-porque__title'
    );
    if (!candidates.length) return;

    const burst = () => {
      const el = candidates[Math.floor(Math.random() * candidates.length)];
      /* 3-flash CA sequence â€” text-shadow only, never touch DOM content */
      const offsets = [0, 90, 180];
      offsets.forEach(delay => {
        setTimeout(() => {
          const mag = 5 - delay / 60;
          el.style.textShadow = `-${mag}px 0 rgba(255,0,80,0.7), ${mag}px 0 rgba(0,200,255,0.7)`;
          setTimeout(() => { el.style.textShadow = ''; }, 80);
        }, delay);
      });
      setTimeout(burst, 5000 + Math.random() * 9000);
    };

    setTimeout(burst, 6000);
  }

  /* ----------------------------------------------------------
     INIT
  ---------------------------------------------------------- */
  initLoadBar();

  /* ----------------------------------------------------------
     HERO SCRAMBLE EFFECTS â€” letter distortion sequences
     Uses an overlay div so h1 DOM is never mutated.
     h1 goes color:transparent while overlay is visible.
  ---------------------------------------------------------- */
  function initHeroScrambleEffect() { /* eliminado — afecta experiencia del usuario */ }

  /* initB2BGlitch — stub (función legacy eliminada, llamada preservada por compatibilidad) */
  function initB2BGlitch() {}

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Fase 1: init crítico — sin manipulación de layout */
    initGlitch();
    initHoverScramble();
    initReveal();
    initScrollHeader();
    initFaqAccordion();
    initMagneticButtons();
    initClickRipple();
    initStickyWA();
    initScrollProgress();
    initCardTilt();

    /* Fase 2: diferido tras primer paint — evita CLS en métricas LCP/CLS */
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        initTypewriter();
        initCounters();
        initTextScramble();
        initRandomGlitch();
        initHeadingCA();
        initNosotrosCounters();
        initUrgencyTicker();
        initHeroHeadingEffects();
        initHeroScrambleEffect();
        initCyclicTitleEffects();
        initProcessConnector();
        /* WR-LIMPIEZA-V1: initSectionLabels() desactivado ("// READY" de consola en las secciones) */
        initStatCompleteCA();
        initTitleGlitchBurst();
              /* WR-CLEAN-BG-V1: initCursorGlow() desactivado (brillo que seguía al mouse) */
        if (!reduceMotion) initParticles();
        if (!reduceMotion) initDataStream();
      });
    });
  }

})();


